import { __decorate } from "tslib";
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import PaymentOptionFormMixin from '@/helpers/vue_mixins/v2/PaymentOptionFormMixin';
import RouterParamsAppMixin from '@/helpers/vue_mixins/RouterParamsAppMixin';
import ActionButton from '@/components/action_button/Index.vue';
import FormHeader from '@/components/v2/FormHeader.vue';
import BaseTextField from '@/components/v2/BaseTextField.vue';
import ViewportSizeMixin from '@/helpers/mixins/ViewportSizeMixin';
let PaymentShippingRequiredDialog = class PaymentShippingRequiredDialog extends mixins(PaymentOptionFormMixin, RouterParamsAppMixin, ViewportSizeMixin) {
    onSubmit() {
        this.$router.push({ name: 'ecommerce-shipping' });
    }
};
PaymentShippingRequiredDialog = __decorate([
    Component({
        components: {
            ActionButton,
            BaseTextField,
            FormHeader,
        },
    })
], PaymentShippingRequiredDialog);
export default PaymentShippingRequiredDialog;
